<template>
  <a-modal
    :visible="visible"
    title="Selecciona una tipificación por defecto"
    width="400px"
    :mask-closable="false"
    centered
    :keyboard="false"
    @cancel="handleConfirmationClose"
  >
    <div class="information">
      <span
        >Recuerda que esta tipificación se ejecutará despues de terminado el contador de ACW y se
        guardará como una gestión de manera automática.
      </span>
    </div>
    <CustomScrollbar class="bodyStyle" v-if="isEmpty">
      <div class="container__text">
        <img :src="workspaceImage" alt="workspace" />
        <span class="nofound"
          >No hemos podido detectar ninguna tipificación guardada en esta campaña.
        </span>
      </div>
    </CustomScrollbar>
    <CustomScrollbar v-else class="bodyStyle">
      <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
        <a-form-item name="name">
          <span class="title__form">Seleccione un grupo</span>
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.name"
            placeholder="Seleccione un grupo"
            @change="changeGroupType"
          >
            <a-select-option v-for="groupType in typification" :key="groupType.name">
              {{ groupType.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="results && results.length !== 0" name="result_type">
          <span class="title__form">Selecciona un resultado</span>
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.result_type"
            placeholder="Seleccione un resultado"
            @change="changeResultType"
          >
            <a-select-option v-for="result in results" :key="result.id">
              {{ result.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="motives && motives.length !== 0">
          <span class="title__form">Selecciona un motivo</span>
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.motive_type"
            placeholder="Seleccione un motivo"
            @change="changeMotiveType"
          >
            <a-select-option v-for="groupType in motives" :key="groupType.id">
              {{ groupType.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="submotives && submotives.length !== 0">
          <span class="title__form">Selecciona un submotivo</span>
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.sub_motive_type"
            placeholder="Seleccione un Submotivo"
          >
            <a-select-option v-for="groupType in submotives" :key="groupType.id">
              {{ groupType.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </CustomScrollbar>

    <!--Fotter Modal -->
    <template v-slot:footer>
      <a-button @click="handleCancel"> Cancelar </a-button>
      <a-button type="primary" @click="handleOk" :disabled="isEmpty">
        Guardar tipificación por defecto
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { defineComponent, reactive, ref, toRaw, computed, createVNode } from "vue";
import { useStore } from "vuex";
import { Modal } from "ant-design-vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import workspaceImage from "@/app/workspace/assets/workspace3.png";

export default defineComponent({
  components: {
    CustomScrollbar,
  },
  props: {
    record: {
      type: Object,
      default: null,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const formRef = ref();
    let formState = reactive({
      name: "",
      group_type: "",
      result_type: "",
      motive_type: "",
      sub_motive_type: "",
    });
    const store = useStore();
    const typification = computed(() => store.getters["getTypificationSaved"]);
    const isEmpty = computed(() => typification.value.length === 0);

    if (props.record) {
      let groupType = typification.value.find((item) => item.name == props.record.name);
      formState = reactive({
        name: props.record.name,
        group_type: groupType?.id,
        result_type: props.record.result_type,
        motive_type: props.record.motive_type,
        sub_motive_type: props.record.sub_motive_type,
      });
    }
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
      result_type: [{ required: true, message: "Campo requerido" }],
    };
    return {
      formRef,
      formState,
      rules,
      isEmpty,
    };
  },
  // data() {
  //   return {
  //     visible: false,
  //   };
  // },
  computed: {
    groupTypes() {
      return this.$store.getters["getGroupTypes"];
    },
    typification() {
      return this.$store.getters["getTypificationSaved"];
    },
    results() {
      if (!this.typification || this.formState.name == "") return [];
      return this.typification.find((item) => item.name == this.formState.name)?.children;
    },
    motives() {
      if (!this.results || this.formState.result_type == "") return undefined;
      return this.results.find((item) => item.id == this.formState.result_type)?.children;
    },
    submotives() {
      if (!this.motives || this.formState.motive_type == "") return undefined;
      return this.motives.find((item) => item.id == this.formState.motive_type)?.children;
    },
  },
  methods: {
    handleOk() {
      this.formRef.validateFields().then(() => {
        let values = toRaw(this.formState);
        const body = {
          name: values.name,
          group_type: values.group_type,
          result_type: values.result_type,
          motive_type: values.motive_type,
          sub_motive_type: values.sub_motive_type,
        };
        // this.visible = false;
        this.$emit("push", body);
        this.handleCancel();
      });
    },
    // handleShowModal() {
    //   this.visible = true;
    // },
    handleCancel() {
      // this.visible = false;
      this.$emit("close");
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Estás seguro de cerrar el proceso?",
        content: "Al cerrar no se guardarán los datos previamente ingresados",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Cerrar",
        cancelText: "Cancelar",
      });
    },
    changeGroupType() {
      this.formState.result_type = "";
      this.formState.motive_type = "";
      this.formState.sub_motive_type = "";
      let groupType = this.typification.find((item) => item.name == this.formState.name);
      this.formState.group_type = groupType.id;
    },
    changeResultType() {
      this.formState.motive_type = "";
      this.formState.sub_motive_type = "";
    },
    changeMotiveType() {
      this.formState.sub_motive_type = "";
    },
  },
});
</script>

<style lang="sass" scoped>
.ant-form-item
  margin-bottom: 16px

.text
  font-weight: 600
  color: $gray-9
  &--small
    color: $gray-7
    font-size: 12px
    margin-left: 20px
    font-weight: normal

.bodyStyle
  padding: 24px 48px
  height: 350px

.title__form
  font-weight: 600

.nofound
  color: #BFBFBF
  font-weight: 400
  font-size: 12px

.container__text
  padding: 40px 3px
  text-align: center
</style>
